<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">ESPAÑOL</span>
          <small>DIRECTORY</small>
          <span class="tagline">FOR US. BY US. — POWERED BY UMYO.</span>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link" routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link active" routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Card</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/hardship" (click)="isNavOpen = false">Hardship Incentives</a></li>
        </ul>
      </div>

      <div class="d-none d-md-flex align-items-center gap-2">
        <div class="lang-switch">
          <button type="button" class="lang-btn" [class.active]="lang === 'en'" (click)="setLang('en')">EN</button>
          <button type="button" class="lang-btn" [class.active]="lang === 'es'" (click)="setLang('es')">ES</button>
        </div>

        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">{{ t.nav.login }}</a>
        <a href="/?authTab=register#register" class="btn btn-pink">{{ t.nav.register }}</a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ PACKAGES HERO ============ -->
<section class="pkg-hero">
  <div class="container">
    <p class="pkg-tagline">{{ t.hero.tagline }}</p>

    <div class="row align-items-center pkg-hero-row">
      <div class="col-lg-5 position-relative">
        <h1 class="pkg-hero-title">
          {{ t.hero.title }}<br>
          <span class="text-pink">{{ t.hero.titleHighlight }}</span><br>
          {{ t.hero.titleEnd }}
        </h1>
        <p class="pkg-hero-desc">{{ t.hero.desc }}</p>
        <a href="/?authTab=register#register" class="btn btn-pink">
          {{ t.hero.cta }}
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14"/><path d="M13 5l7 7-7 7"/>
          </svg>
        </a>
      </div>

      <div class="col-lg-7">
      </div>
    </div>

    <div class="pkg-feature-strip">
      <div class="pkg-feature-item">
        <span class="pkg-feature-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </span>
        <div>
          <strong>{{ t.features.one.title }}</strong>
          <span>{{ t.features.one.subtitle }}</span>
        </div>
      </div>

      <div class="pkg-feature-item">
        <span class="pkg-feature-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z"/>
          </svg>
        </span>
        <div>
          <strong>{{ t.features.two.title }}</strong>
          <span>{{ t.features.two.subtitle }}</span>
        </div>
      </div>

      <div class="pkg-feature-item">
        <span class="pkg-feature-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 17l6-6 4 4 8-8"/><path d="M17 7h4v4"/>
          </svg>
        </span>
        <div>
          <strong>{{ t.features.three.title }}</strong>
          <span>{{ t.features.three.subtitle }}</span>
        </div>
      </div>
    </div>

  </div>
</section>

<!-- ============ MEMBER PACKAGES ============ -->
<section class="pkg-packages-section">
  <div class="container">

    <div class="pkg-divider">
      <span class="line"></span>
      <h2>{{ t.memberPackages.title }}</h2>
      <span class="line"></span>
    </div>

    <div class="pkg-tier-grid">

      <!-- STARTER -->
      <div class="pkg-tier-card">
        <div class="pkg-tier-header"><span>{{ t.memberPackages.starter.name }}</span></div>
        <div class="pkg-tier-body">
          <h3 class="pkg-tier-price">{{ t.memberPackages.starter.price }}</h3>
          <p class="pkg-tier-desc">{{ t.memberPackages.starter.desc }}</p>

          <ul class="pkg-tier-list">
            <li *ngFor="let feature of t.memberPackages.starter.features">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg>
              {{ feature }}
            </li>
          </ul>

          <div class="pkg-tier-benefit">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-label">{{ t.memberPackages.starter.benefit.label }}</strong>
              <span class="pkg-benefit-title">{{ t.memberPackages.starter.benefit.title }}</span>
              <p>{{ t.memberPackages.starter.benefit.desc }}</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-tier-btn">{{ t.memberPackages.starter.cta }}</a>
        </div>
      </div>

      <!-- CONNECT -->
      <div class="pkg-tier-card">
        <div class="pkg-tier-header"><span>{{ t.memberPackages.connect.name }}</span></div>
        <div class="pkg-tier-body">
          <h3 class="pkg-tier-price">{{ t.memberPackages.connect.price }}</h3>
          <p class="pkg-tier-desc">{{ t.memberPackages.connect.desc }}</p>

          <ul class="pkg-tier-list">
            <li *ngFor="let feature of t.memberPackages.connect.features">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg>
              {{ feature }}
            </li>
          </ul>

          <div class="pkg-tier-benefit pkg-benefit-green">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2 4-4"/><path d="M7 13a4 4 0 1 1 4-4"/><path d="M18 16.5V13a2 2 0 0 0-4 0v1"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-label">{{ t.memberPackages.connect.benefit.label }}</strong>
              <span class="pkg-benefit-title">{{ t.memberPackages.connect.benefit.title }}</span>
              <p>{{ t.memberPackages.connect.benefit.desc }}</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-tier-btn">{{ t.memberPackages.connect.cta }}</a>
        </div>
      </div>

      <!-- GROW -->
      <div class="pkg-tier-card">
        <div class="pkg-tier-header"><span>{{ t.memberPackages.grow.name }}</span></div>
        <div class="pkg-tier-body">
          <h3 class="pkg-tier-price">{{ t.memberPackages.grow.price }}</h3>
          <p class="pkg-tier-desc">{{ t.memberPackages.grow.desc }}</p>

          <ul class="pkg-tier-list">
            <li *ngFor="let feature of t.memberPackages.grow.features">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg>
              {{ feature }}
            </li>
          </ul>

          <div class="pkg-tier-benefit">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-label">{{ t.memberPackages.grow.benefit.label }}</strong>
              <span class="pkg-benefit-title">{{ t.memberPackages.grow.benefit.title }}</span>
              <p>{{ t.memberPackages.grow.benefit.desc }}</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-tier-btn">{{ t.memberPackages.grow.cta }}</a>
        </div>
      </div>

      <!-- PRO -->
      <div class="pkg-tier-card">
        <div class="pkg-tier-header"><span>{{ t.memberPackages.pro.name }}</span></div>
        <div class="pkg-tier-body">
          <h3 class="pkg-tier-price">{{ t.memberPackages.pro.price }}</h3>
          <p class="pkg-tier-desc">{{ t.memberPackages.pro.desc }}</p>

          <ul class="pkg-tier-list">
            <li *ngFor="let feature of t.memberPackages.pro.features">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg>
              {{ feature }}
            </li>
          </ul>

          <div *ngFor="let benefit of t.memberPackages.pro.benefits" class="pkg-tier-benefit" [class.pkg-benefit-green]="benefit.title === 'VERIFIED MEMBER' || benefit.title === 'MIEMBRO VERIFICADO'" [class.pkg-benefit-gold]="benefit.title === 'FEATURED MEMBER' || benefit.title === 'MIEMBRO DESTACADO'">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m9 12 2 2 4-4"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-label">{{ benefit.label }}</strong>
              <span class="pkg-benefit-title">{{ benefit.title }}</span>
              <p>{{ benefit.desc }}</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-tier-btn">{{ t.memberPackages.pro.cta }}</a>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ============ BUSINESS PACKAGES ============ -->
<section class="pkg-biz-section">
  <div class="container">

    <div class="pkg-divider">
      <span class="line"></span>
      <h2>{{ t.businessPackages.title }}</h2>
      <span class="line"></span>
    </div>

    <div class="pkg-biz-grid">

      <!-- BUSINESS -->
      <div class="pkg-biz-card">
        <div class="pkg-biz-header">
          <span class="pkg-biz-icon">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="7" width="18" height="12" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
            </svg>
          </span>
          <div>
            <strong>{{ t.businessPackages.business.name }}</strong>
            <span class="pkg-biz-tag">{{ t.businessPackages.business.tag }}</span>
          </div>
        </div>

        <div class="pkg-biz-body">
          <h3 class="pkg-biz-price">{{ t.businessPackages.business.price }} <span>{{ t.businessPackages.business.priceSuffix }}</span></h3>
          <p class="pkg-biz-desc">{{ t.businessPackages.business.desc }}</p>

          <div class="pkg-biz-list-grid">
            <ul>
              <li *ngFor="let feature of t.businessPackages.business.features | slice:0:5">{{ feature }}</li>
            </ul>
            <ul>
              <li *ngFor="let feature of t.businessPackages.business.features | slice:5:9">{{ feature }}</li>
            </ul>
          </div>

          <div class="pkg-tier-benefit pkg-benefit-green">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2 4-4"/><path d="M7 13a4 4 0 1 1 4-4"/><path d="M18 16.5V13a2 2 0 0 0-4 0v1"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-label">{{ t.businessPackages.business.benefit.label }}</strong>
              <span class="pkg-benefit-title">{{ t.businessPackages.business.benefit.title }}</span>
              <p>{{ t.businessPackages.business.benefit.desc }}</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-biz-btn">{{ t.businessPackages.business.cta }}</a>
        </div>
      </div>

      <!-- BUSINESS PRO -->
      <div class="pkg-biz-card pkg-biz-pro">
        <span class="pkg-best-ribbon">{{ t.businessPackages.businessPro.badge }}</span>

        <div class="pkg-biz-header pkg-biz-header-gold">
          <span class="pkg-biz-icon pkg-biz-icon-gold">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="m2 8 4 3 6-7 6 7 4-3-2 11H4L2 8Z"/>
            </svg>
          </span>
          <div>
            <strong>{{ t.businessPackages.businessPro.name }}</strong>
            <span class="pkg-biz-tag pkg-biz-tag-gold">{{ t.businessPackages.businessPro.tag }}</span>
          </div>
        </div>

        <div class="pkg-biz-body">
          <h3 class="pkg-biz-price pkg-biz-price-gold">{{ t.businessPackages.businessPro.price }}</h3>
          <p class="pkg-biz-desc">{{ t.businessPackages.businessPro.desc }}</p>

          <p class="pkg-biz-plus-label">{{ t.businessPackages.businessPro.includes }}</p>

          <div class="pkg-biz-pro-inner">
            <div class="pkg-biz-pro-left">
              <div class="pkg-biz-list-grid">
                <ul>
                  <li *ngFor="let feature of t.businessPackages.businessPro.features | slice:0:4">{{ feature }}</li>
                </ul>
                <ul>
                  <li *ngFor="let feature of t.businessPackages.businessPro.features | slice:4:9">{{ feature }}</li>
                </ul>
              </div>
            </div>

            <div class="pkg-biz-pro-right">
              <div *ngFor="let benefit of t.businessPackages.businessPro.benefits" class="pkg-pro-side-item" [class.pkg-benefit-green]="benefit.title === 'ACCEPTING CLIENTS'" [class.pkg-benefit-gold]="benefit.title === 'OFFERS DISCOUNTS' || benefit.title === 'FEATURED BUSINESS' || benefit.title === 'OFREECE DESCUENTOS' || benefit.title === 'NEGOCIO DESTACADO'">
                <span class="pkg-benefit-icon">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2 4-4"/><path d="M7 13a4 4 0 1 1 4-4"/><path d="M18 16.5V13a2 2 0 0 0-4 0v1"/></svg>
                </span>
                <div>
                  <strong>{{ benefit.title }}</strong>
                  <p>{{ benefit.desc }}</p>
                </div>
              </div>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-biz-btn pkg-biz-btn-pink">{{ t.businessPackages.businessPro.cta }}</a>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ============ DIRECTORY ADVANTAGES + ALL PACKAGES INCLUDE ============ -->
<section class="pkg-discover-section">
  <div class="container">
    <div class="row gx-4">

      <div class="col-lg-7 mb-4 mb-lg-0">
        <div class="pkg-discover-card">
          <h3 class="pkg-discover-title">{{ t.directoryAdvantages.title }}</h3>
          <p class="pkg-discover-sub">{{ t.directoryAdvantages.subtitle }}</p>

          <table class="pkg-discover-table">
            <thead>
              <tr><th>DIRECTORY FEATURE</th><th>INCLUDED WITH</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let feature of t.directoryAdvantages.features">
                <td>
                  <span class="pkg-table-icon" [class.green]="feature.name === 'Available for Hire' || feature.name === 'Verified Member' || feature.name === 'Accepting Clients' || feature.name === 'Disponible para Contratar' || feature.name === 'Miembro Verificado' || feature.name === 'Aceptando Clientes'">
                    <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
                    </svg>
                  </span>
                  {{ feature.name }}
                </td>
                <td>{{ feature.packages }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="pkg-include-card">
          <h3 class="pkg-include-title">{{ t.allInclude.title }}</h3>
          <p class="pkg-include-sub">{{ t.allInclude.subtitle }}</p>

          <div class="pkg-include-grid">
            <div *ngFor="let item of t.allInclude.items" class="pkg-include-item">
              <span class="pkg-include-icon">
                <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s7-3.5 7-9V5l-7-3-7 3v8c0 5.5 7 9 7 9Z"/></svg>
              </span>
              <strong>{{ item.title }}</strong>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ============ ECOSYSTEM BANNER ============ -->
<section class="pkg-cta-section">
  <div class="container">
    <div class="pkg-ecosystem-banner">

      <div class="pkg-ecosystem-left">
        <span class="pkg-ecosystem-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </span>
        <div>
          <h4>{{ t.ecosystem.title }}</h4>
          <p class="mb-0">{{ t.ecosystem.desc }}</p>
        </div>
      </div>

      <div class="pkg-ecosystem-mid">
        <p>{{ t.ecosystem.quote }}</p>
      </div>

      <div class="pkg-ecosystem-cta">
        <h4>{{ t.ecosystem.ctaTitle }}</h4>
        <a href="/?authTab=register#register" class="btn pkg-ecosystem-btn">{{ t.ecosystem.cta }}</a>
      </div>

    </div>
  </div>
</section>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">ESPAÑOL</span></div>
        </div>
        <small class="d-block pkg-footer-muted">{{ t.footer.tagline }}</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.quickLinks }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.resources }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="#">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">{{ t.footer.connect }}</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>{{ t.footer.copyright }}</small>
    </div>
  </div>
</footer>